"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWithMenu = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const Theme_1 = require("../../styles/Theme");
const TabWithMenu = (props) => {
    const TabVariant = (0, react_1.useMemo)(() => (props.variant === 'external' ? ExternalTab : InternalTab), [props.variant]);
    if (props.items) {
        // Replace base Tab Component with a custom component that has a menu
        const component = () => react_1.default.createElement(MenuTab, Object.assign({}, props));
        return react_1.default.createElement(TabVariant, Object.assign({}, props, { component: component }));
    }
    return react_1.default.createElement(TabVariant, Object.assign({}, props, { disableRipple: true }));
};
exports.TabWithMenu = TabWithMenu;
const MenuTab = (_a) => {
    var { label, items, variant } = _a, props = __rest(_a, ["label", "items", "variant"]);
    // From MUI Documentation https://mui.com/material-ui/react-menu/
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [TabVariant, KeyboardDownIconVariant] = useVariantComponents(variant);
    const hoverColor = (0, react_1.useMemo)(() => (variant === 'external' ? 'primary.light' : 'primary.main'), [variant]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TabVariant, Object.assign({ onClick: handleOpen }, props),
            react_1.default.createElement(material_1.Box, { sx: {
                    color: anchorEl ? hoverColor : '.primary',
                    '&:hover': {
                        color: hoverColor,
                    },
                }, component: "span" }, label),
            react_1.default.createElement(KeyboardDownIconVariant, { sx: {
                    height: '20px',
                    width: '20px',
                    path: {
                        color: anchorEl ? hoverColor : '.primary',
                    },
                } })),
        react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, disableAutoFocusItem: true }, items === null || items === void 0 ? void 0 : items.map(({ label: tabLabel, onClickSubMenu }) => (react_1.default.createElement(material_1.MenuItem, { key: tabLabel, onClick: () => {
                handleClose();
                onClickSubMenu();
            } }, tabLabel))))));
};
const useVariantComponents = (variant) => (0, react_1.useMemo)(() => variant === 'internal' ? [InternalTabBox, InternalKeyboardDownIcon] : [ExternalTabBox, ExternalKeyboardDownIcon], [variant]);
const TabBoxBase = (0, Theme_1.driftStyled)(material_1.Box)({
    all: 'unset',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    gap: '1px',
    paddingTop: '1.2rem',
    paddingBottom: '1.2rem',
    height: '1rem',
});
const ExternalTabBox = (0, Theme_1.driftStyled)(TabBoxBase)(({ theme }) => ({
    color: theme.palette.blue['500'],
    fontWeight: 600,
    '&:hover': {
        color: theme.palette.primary.light,
        path: {
            color: theme.palette.primary.light,
        },
    },
}));
const ExternalTab = (0, Theme_1.driftStyled)(material_1.Tab)(({ theme }) => ({
    minWidth: 'auto',
    '&.MuiTab-root': {
        fontWeight: 600,
        color: theme.palette.primary.main,
        padding: '1.2rem 0',
        '&:hover': {
            color: theme.palette.primary.light,
        },
        '&.Mui-selected': {
            color: theme.palette.gray['900'],
            cursor: 'default',
        },
    },
}));
const InternalTabBox = (0, Theme_1.driftStyled)(TabBoxBase)(({ theme }) => ({
    minWidth: 'auto',
    fontWeight: 400,
    color: theme.palette.gray['700'],
    '&:hover': {
        color: theme.palette.primary.main,
        path: {
            color: theme.palette.primary.main,
        },
    },
}));
const InternalTab = (0, Theme_1.driftStyled)(material_1.Tab)(({ theme }) => ({
    minWidth: 'auto',
    '&.MuiTab-root': {
        fontWeight: 400,
        color: theme.palette.gray['700'],
        padding: '1.2rem 0',
        '&:hover': {
            color: theme.palette.primary.main,
            path: {
                color: theme.palette.primary.main,
            },
        },
        '&.Mui-selected': {
            '&:hover': {
                color: theme.palette.gray['700'],
                cursor: 'default',
            },
            fontWeight: 700,
        },
    },
}));
const ExternalKeyboardDownIcon = (0, Theme_1.driftStyled)(KeyboardArrowDown_1.default)(({ theme }) => ({
    color: theme.palette.blue['500'],
}));
const InternalKeyboardDownIcon = (0, Theme_1.driftStyled)(KeyboardArrowDown_1.default)(({ theme }) => ({
    color: theme.palette.gray['700'],
}));
//# sourceMappingURL=SecondaryNavigationTab.js.map